export default __webpack_public_path__ + "static/media/line_brain.7de76442.png";